import { getAMap } from '@/libs/AMap'

// 创建高德地图定位实例
export async function createGeolocation() {
  const AMap = await getAMap()

  return new AMap.Geolocation({
    enableHighAccuracy: true,
    timeout: 10000,
    getCityWhenFail: true,
    noIpLocate: false,
    noGeoLocation: false
  })
}

// 获取当前定位
export async function getCurrentPosition() {
  const geolocation = await createGeolocation()

  return new Promise((resolve, reject) => {
    geolocation.getCurrentPosition((status, result) => {
      resolve({ status, result })
    })
  })
}

// 获取当前城市
export async function getCityInfo() {
  const geolocation = await createGeolocation()

  return new Promise((resolve, reject) => {
    geolocation.getCityInfo((status, result) => {
      resolve({ status, result })
    })
  })
}

// 查询城市信息
export async function searchCity(cityName) {
  const AMap = await getAMap()
  const geocoder = new AMap.Geocoder()
  return new Promise((resolve, reject) => {
    geocoder.getLocation(cityName, (status, result) => {
      resolve({ status, result })
    })
  })
}

// 根据金纬度获取地址信息
export async function getAddressInfo(lng, lat) {
  const AMap = await getAMap()
  const geocoder = new AMap.Geocoder()
  return new Promise((resolve, reject) => {
    geocoder.getAddress(
      [lng, lat],
      (status, result) => {
        resolve({ status, result })
      }
    )
  })
}
